"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _chartsReact = require("@carbon/charts-react");
require("@carbon/charts/styles.css");
var _getColor = require("../../../common/getColor");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.radarChart-container {\n  transition: all 0.4s ease-in-out;\n  overflow: hidden; }\n  .radarChart-container .y-axes {\n    display: none; }\n  .radarChart-container > div {\n    overflow-x: auto;\n    overflow-y: hidden; }\n  .radarChart-container .chart-holder {\n    margin-bottom: 24px; }\n  .radarChart-container .y-labels {\n    display: none; }\n  .radarChart-container .none .blob {\n    fill-opacity: 0 !important; }\n  .radarChart-container .low .blob {\n    fill-opacity: 0.3 !important; }\n  .radarChart-container .medium .blob {\n    fill-opacity: 0.5 !important; }\n  .radarChart-container .fill .blob {\n    fill-opacity: 1 !important; }\n  .radarChart-container text {\n    font-family: 'Helvetica Neue LT Roman'; }\n  .radarChart-container .multi-tooltip p {\n    font-family: 'Helvetica Neue LT Roman'; }\n";
  const fileName = "RadarChart_RadarChart";
  const element = document.querySelector("style[data-sass-component='RadarChart_RadarChart']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const Chart = /*#__PURE__*/_react.default.memo(_ref => {
  let {
    formatedItems,
    options
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_chartsReact.RadarChart, {
    data: formatedItems,
    options: options
  });
}, () => true);
const RadarChart = _ref2 => {
  let {
    items,
    colors,
    fillMode,
    height,
    width,
    showTotal,
    alignment
  } = _ref2;
  const [formatedItems, setFormatedItems] = (0, _react.useState)([]);
  const [isLoading, setIsLoading] = (0, _react.useState)(true);
  const ref = (0, _react.useRef)();
  (0, _react.useEffect)(() => {
    setIsLoading(true);
    setTimeout(() => {
      formatItems();
      const wrapper = ref?.current?.getElementsByClassName('cds--cc--chart-wrapper') && ref?.current?.getElementsByClassName('cds--cc--chart-wrapper')[0];
      if (wrapper) {
        wrapper.addEventListener('mouseover', addNewRowInTooltip);
      }
    }, 100);
  }, [items]);
  const formatItems = () => {
    const formatedItemsAux = [];
    const xAxes = [];
    Object.entries(items).forEach(item => {
      Object.entries(item[1]).forEach(value => {
        formatedItemsAux.push({
          product: item[0],
          feature: value[0],
          score: value[1]
        });
        xAxes.push(value[0]);
      });
    });
    setFormatedItems(formatedItemsAux);
    setTimeout(() => {
      formatXAxes([...new Set(xAxes)]);
    }, 1000);
    setIsLoading(false);
  };
  const formatXAxes = () => {
    const yAxes = ref?.current?.getElementsByClassName(`y-axes`) && ref?.current?.getElementsByClassName(`y-axes`)[0];
    const auxValues = yAxes?.children[0]?.getAttribute('transform')?.split(',');
    const xAxes = ref?.current?.getElementsByClassName(`x-axes`) && ref?.current?.getElementsByClassName(`x-axes`)[0];
    if (!auxValues || !xAxes || !xAxes.children) return;
    const {
      xHalf,
      yHalf
    } = {
      xHalf: auxValues[0].replace(/[^\d.-]/g, ''),
      yHalf: auxValues[1].replace(/[^\d.-]/g, '')
    };
    Array.from(xAxes.children)?.forEach(element => {
      element?.setAttribute('x1', xHalf);
      element?.setAttribute('y1', yHalf);
    });
  };
  const addNewRowInTooltip = () => {
    if (!showTotal) return;
    const list = ref?.current?.getElementsByClassName('multi-tooltip') && ref?.current?.getElementsByClassName('multi-tooltip')[0];
    if (!list) return;
    const total = Array.from(list.children)?.reduce((total, el) => total + parseInt(el.getElementsByClassName('value')[0]?.innerHTML || 0), 0);
    if (Array.from(list.children)?.length <= Object.keys(items).length) {
      list.innerHTML += `
        <li>
          <div class="datapoint-tooltip">
            <div class="tooltip-color"></div>
            <div class="label"><p>Total</p></div>
            <p class="value">${total}</p>
          </div>
        </li>
      `;
    }
  };
  const options = {
    radar: {
      axes: {
        angle: 'feature',
        value: 'score'
      },
      alignment: alignment || 'center'
    },
    data: {
      groupMapsTo: 'product'
    },
    height: height,
    width: width || '1056px',
    toolbar: {
      enabled: false
    },
    legend: {
      enabled: false
    },
    getFillColor: group => {
      return colors[group] ? (0, _getColor.getColor)(colors[group]) || colors[group] : '';
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "radarChart-container",
    ref: ref
  }, !isLoading && /*#__PURE__*/_react.default.createElement("div", {
    className: fillMode
  }, /*#__PURE__*/_react.default.createElement(Chart, {
    formatedItems: formatedItems,
    options: options
  })));
};
var _default = exports.default = RadarChart;